export default __webpack_public_path__ + "static/media/so.15e9221c.svg";